import { useTranslation } from 'react-i18next'
import { Badge } from '@/components/ui/badge'
import { cn } from '@/utils/cn'
import { TIER_TONE } from './match-tier'

const PHOTO_MATCHING = 'cases.investigate.entityResolution.photoMatching'

export interface MatchScoreProps {
  /** Already formatted similarity, e.g. `0.71`. */
  score: string
  /** The API's verdict: only a suggested match carries the badge (ADR-0040). */
  suggestedMatch: boolean
  className?: string
}

/** A suggestion's similarity, and the *suggested match* badge when it earned it. */
export function MatchScore({ score, suggestedMatch, className }: MatchScoreProps) {
  const { t } = useTranslation()
  return (
    <span className={cn('inline-flex flex-wrap items-center gap-1.5', className)}>
      <span className="font-medium tabular-nums" data-similarity={score}>
        {score}
      </span>
      {suggestedMatch ? (
        <Badge variant={TIER_TONE.suggested.badge} data-suggested-match="true">
          {t(`${PHOTO_MATCHING}.tiers.suggested`)}
        </Badge>
      ) : null}
    </span>
  )
}

/** How many of an identity's pending suggestions are suggested matches; nothing when none are. */
export function SuggestedMatchesBadge({ count }: { count: number }) {
  const { t } = useTranslation()
  if (count <= 0) return null
  return (
    <Badge variant={TIER_TONE.suggested.badge} data-suggested-matches={count}>
      {t(`${PHOTO_MATCHING}.suggestedMatches`, { count })}
    </Badge>
  )
}
